import { CRM_API, RequestHelper } from "utils";

export const RequestLogService = (() => {

  const listado = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get("requestlog", params);
    });
  };

  const buscarPorId = function (args) {
    return new Promise((res) => res(args)).then((Id) => {
      return RequestHelper(CRM_API).get(`requestlog/${Id}`);
    });
  };

  const exportarExcel = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).post(`requestlog/ExportarExcel`, params, true);
    });
  };

  return { listado, buscarPorId, exportarExcel };
})();